// extracted by mini-css-extract-plugin
export default {"primaryButton":"primary-button_primaryButton__MIGTU","withIcon":"primary-button_withIcon__YDkbI"};